module.exports = __webpack_public_path__ + "img/2.23ec8c7e.png";